import VideoBackground from 'components/video-background'
import textServices from 'services/text-services'
import { AFTERWORK_ASSETS, AFTERWORK_VIDEOS } from '../constants'

// Merch (Figma 43:101): light header + t-shirt spot looping as the media
const MerchSection = () => {
  return (
    <section className="afterwork__merch">
      <div className="afterwork__merch-header">
        <h2 className="afterwork__merch-title">
          {textServices.findByText('afterwork/merch/title', 'Merch Afterwork')}
        </h2>
        <p className="afterwork__merch-description">
          {textServices.findByText(
            'afterwork/merch/description',
            'Diseñada para acompañar una experiencia única. Descúbrela durante el evento.'
          )}
        </p>
      </div>
      <div className="afterwork__merch-media">
        <VideoBackground
          className="afterwork__merch-video"
          src={`${AFTERWORK_ASSETS}/${AFTERWORK_VIDEOS.merch}`}
        />
      </div>
    </section>
  )
}

export default MerchSection
